import React, {useEffect, useState, useRef} from 'react';
import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import Footer from '../../components/Footer/Footer';
import ContactModal from '../../components/ContactModal/ContactModal';
import {Badge, Col, Container, Row, Modal, ModalHeader, ModalBody, Spinner} from 'reactstrap';
import './home.scss'
import Countdown from 'react-countdown';
import {useTranslation, Trans} from 'react-i18next';
import Accordion from '../../components/Accordion/Accordion';
import {handleRegister} from '../../store/actions/register.actions'
import {useDispatch, useSelector} from 'react-redux';
import {useForm} from 'react-hook-form';
import {RegisterSchema} from '../../utils/validationSchemas';
import {yupResolver} from '@hookform/resolvers/yup';
import axios from '../../config/axios-interceptor';
import { useLocation, Link, Redirect } from "react-router-dom";

import DeskSmallImg from '../../assets/images/desk.png';
import DeskMediumImg from '../../assets/images/desk-2.png'
import DeskLargeImg from '../../assets/images/desk-3.png'


const Home = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const message = useSelector((state) => state.register.message);
  const loadingRegistration = useSelector((state) => state.register.loadingRegistration);
  const registrationSuccess = useSelector((state) => state.register.registrationSuccess);

  const {t} = useTranslation();
  const futureDate = new Date("2020-12-01T08:00:00");

  const boothPackages = {
    platinium: 1,
    premium: 2,
    standard: 3
  }

  const [visitor, setVisitor] = useState(false)
  const [boothPreference, setBoothPreference] = useState<number>(boothPackages.premium)
  const [countries, setCountries] = useState([])
  const [sectors, setSectors] = useState([])

  const registerScrollRef = useRef(null)
  const scrollToRef = (ref) => ref.current.scrollIntoView({behavior: 'smooth'})

  const {register, handleSubmit, errors, setValue, getValues} = useForm({
    resolver: yupResolver(RegisterSchema)
  });

  useEffect(()=> {
    if (location.pathname === '/register') {
      setTimeout(() => {
        scrollToRef(registerScrollRef)
      }, 500)
    }
  }, [location])
  
  useEffect(() => {
    if(registrationSuccess) {
      clearRegisterFields()
    }
  }, [registrationSuccess])

  const clearRegisterFields = () => {
    setValue('companyName', '')
    setValue('userName', '')
    setValue('firstName', '')
    setValue('lastName', '')
    setValue('phoneNumber', '')
    setValue('city', '')
    setValue('password', '')
    setValue('confirmPassword', '')
    setValue('visitor', '')
    setValue('numbeEmployees', '')
    setValue('jobPostion', '')
    setValue('GDPRText', false)
  }

  const onRegisterClick = async (data) => {
    const body = {
      ...data,
      visitor: visitor,
      packageId: boothPreference
    }

    dispatch(handleRegister(body))
    toggleModal()
  }

  useEffect(() => {
    getCountries()
    getSectors()
  }, [])

  const getCountries = async () => {
    try {
      const response = await axios.get('Utility/flags');

      if (response.data) {
        setCountries(response.data)
      }
    } catch (err) {
      setCountries([])
    }
  }

  const getSectors = async () => {
    try {
      const response = await axios.get('Utility/sectors');

      if (response.data) {
        setSectors(response.data)
      }
    } catch (err) {
      setSectors([])
    }
  }

  const TimeBadge = ({badgeText, badgeDescription}) => (
    <div className="d-inline-block text-center">
      <Badge className="time-badge border-radius-5">
        <span className="time-badge-text font-weight-bold">{badgeText}</span>
      </Badge>
      <span className="d-block small font-weight-bold mt-1">{badgeDescription}</span>
    </div>
  )

  const CountdownCustomRender = ({days, hours, minutes, seconds, completed}) => {
    if (completed) {
      return <Redirect to="/login" />
    }

    return (
      <div className="app-bg-gray" style={{paddingBottom: '100px'}}>
        <Container>
          <div className="text-center">
            <h3>
              <Trans i18nKey="countDownTitle"/>
            </h3>

            <h1 className="app-text-success font-weight-bold my-4">1 - 2 {t('december')} 2020</h1>

            <div className="d-flex justify-content-center mt-4">
              <TimeBadge badgeText={days} badgeDescription={t('countDownDays')}/>
              <span className="h3 mt-2 mx-2 mx-sm-3">:</span>
              <TimeBadge badgeText={hours} badgeDescription={t('countDownHours')}/>
              <span className="h3 mt-2 mx-2 mx-sm-3">:</span>
              <TimeBadge badgeText={minutes} badgeDescription={t('countDownMinutes')}/>
              <span className="h3 mt-2 mx-2 mx-sm-3">:</span>
              <TimeBadge badgeText={seconds} badgeDescription={t('countDownSeconds')}/>
            </div>

            <Button onClick={() => scrollToRef(registerScrollRef)}
              text={t('registerBtn')}
              type="successTransparent"
              className="mt-4"/>
          </div>
        </Container>
      </div>
    )
  };

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const [contactModal, setContactModal] = useState(false);
  const toggleContactModal = () => setContactModal(!contactModal);

  return (
    <div>
      <div onClick={toggleContactModal} className="app-bg-primary p-2 rounded-circle position-fixed" style={{cursor: 'pointer', width: '100px', height: '100px', right: '15px', bottom: '30px', zIndex: 1000}}>
        <div className="rounded-circle text-center w-100 h-100 pt-2" style={{ border: '4px solid #80C32D' }}>
          <img src={require("../../assets/images/user-icon.png")} />
          <div className="app-text-success d-inline-block font-weight-bold w-75 text-center text-uppercase mt-1" style={{ fontSize: '11px', lineHeight: '1.2'}}>{t('contactFixedBtn')}</div>
        </div>
      </div>

      <ContactModal toggleContactModal={toggleContactModal} isOpen={contactModal} />

      <Modal isOpen={modal} toggle={toggleModal} contentClassName="border-0"
             style={{boxShadow: '0px 0px 10px 0px #80C32D', border: '2px solid #80C32D', borderRadius: '6px'}}>
        <ModalHeader toggle={toggleModal} style={{border: 'none'}}></ModalHeader>
        <ModalBody className="pb-5 pt-3">
          {loadingRegistration ?
            <div className="text-center">
              <Spinner color="success"/>
            </div>
            :
            <h2 className="text-center">{message}</h2>}
        </ModalBody>
      </Modal>


      <Header/>
      <Container>
        <div className="text-center my-5">
          <img style={{width: '100%', maxWidth: 400}} src={require('../../assets/images/klubi-logo.png')}/>
        </div>
      </Container>


      <div className="btn1">
        <img
          src={DeskMediumImg}
          srcSet={`${DeskLargeImg} 1920w, ${DeskMediumImg} 1500w, ${DeskSmallImg} 500w`}
          className="w-100"
        />

          <div className="d-none d-md-block text-upercase font-weight-bold small" style={{
            position: 'absolute',
            left: '16%',
            bottom: '30%'
          }}>{t('supportedByText')}</div>
        <div className="d-none d-lg-block">
          <Button onClick={() => scrollToRef(registerScrollRef)}
            text={t('RegisterBtnDesk')}
            type="deskbutton"
            className="deskbutton btn11"
          />
          <Link to="/lobby">
            <Button
              text={t('LobbyBtnDesk')}
              type="deskbutton"
              className="deskbutton btn12"
            />
          </Link>
          <Link to="/booths">
            <Button
              text={t('GreenPavBtnDesk')}
              type="deskbutton"
              className="deskbutton btn13"
            />
          </Link>
          <Link to="/greenforums">
          <Button
            text={t('GreenForBtnDesk')}
            type="deskbutton"
            className="deskbutton btn14"
          />
          </Link>
          <Button
            text={t('B2bBtnDesk')}
            type="deskbutton"
            className="deskbutton btn15"
          />
          <div className="icons1">
            <a href="https://www.facebook.com/KosovoGreen">
              <img className="mb-4 mr-3" style={{maxWidth: '22%'}}
                   src={require('../../assets/images/fb-white.png')}/>
            </a>
            <a href="https://www.instagram.com/greenbusinesskosovo">
              <img className="mb-4 mr-3" style={{maxWidth: '22%'}}
                   src={require('../../assets/images/insta-white.png')}/>
            </a>
            <a href="https://www.linkedin.com/in/kosovo-manufacturing-club-8033b21a1/">
            <img className="mb-4" style={{maxWidth: '22%'}}
                 src={require('../../assets/images/in-white.png')}/>
            </a>
          </div>
        </div>
      </div>

      <Countdown date={futureDate} renderer={CountdownCustomRender}/>

      <div className="app-bg-gray">
        <Container className="about-wrapper">
          <div className="about-inner-wrapper">

            <div className="about-column-1">
              <div className="app-bg-success about-column-1-inner">
                <div className="app-bg-primary p-3 px-5 about-column-text-wrp">
                  <p className="text-uppercase text-white m-0">{t('aboutTitle')}</p>
                  <h4 className="text-uppercase font-weight-bold text-white m-0">{t('aboutSubtitle')}</h4>
                </div>

                <div className="text-white small">
                  <p>{t('aboutParagraph1')}</p>
                  <p>{t('aboutParagraph2')}</p>

                  <ul>
                    <li><Trans i18nKey="aboutUnOrderedList1"/></li>
                    <li><Trans i18nKey="aboutUnOrderedList2" value={5}/></li>
                    <li><Trans i18nKey="aboutUnOrderedList3"/></li>
                  </ul>

                  <p>{t('aboutParagraph3')}</p>
                </div>

                <Button onClick={() => scrollToRef(registerScrollRef)}
                  type="primaryTransparent"
                  text={t("registerBtn")}/>
              </div>
            </div>

            <div className="about-column-2">
              <div className="about-column-2-img"></div>
              <div className="text-right">
                <p
                  className="small text-muted mt-2 d-inline-block about-image-description">{t('aboutImageDescription')}</p>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <Container className="mt-5">
        <div className="text-center pb-5">
          <h1 className="font-weight-bold">{t('virtualBoothsTitle')}</h1>
          <p className="w-50 mx-auto">{t('virtualBoothsSubtitle')}</p>
        </div>
        <Row>
          <Col sm={6} md={3} className="mb-4 mb-md-0">
            <img className="mb-3 mx-auto d-block app-landing-page-icon"
                 src={require('../../assets/images/5.png')}/>
            <p className="text-center w-75 mx-auto mt-3">{t('construction')}</p>
          </Col>
          <Col sm={6} md={3} className="mb-4 mb-md-0">
            <img className="mb-3 mx-auto d-block app-landing-page-icon"
                 src={require('../../assets/images/6.png')}/>
            <p className="text-center w-75 mx-auto">{t('energyEfficiency')}</p>
          </Col>
          <Col sm={6} md={3} className="mb-4 mb-md-0">
            <img className="mb-3 mx-auto d-block app-landing-page-icon"
                 src={require('../../assets/images/10.png')}/>
            <p className="text-center w-75 mx-auto">{t('renewableEnergy')}</p>
          </Col>
          <Col sm={6} md={3} className="mb-4 mb-md-0">
            <img className="mb-3 mx-auto d-block app-landing-page-icon"
                 src={require('../../assets/images/7.png')}/>
            <p className="text-center w-75 mx-auto">{t('recycling')}</p>
          </Col>
        </Row>
      </Container>

      <Container className="p-md-5">
        <Row>
          <Col md={6} className="mb-4 mb-md-0">
            <div className="app-bg-primary p-4 h-100">
              <h3 className="app-text-success mb-4">{t('whyAttendTitle')}</h3>
              <p className="text-white">{t('whyAttendParagraph1')}</p>
              <p className="text-white">{t('whyAttendParagraph2')}</p>
            </div>
          </Col>
          <Col md={6}>
            <div className="app-bg-success p-4 h-100 text-right">
              <h3 className="app-text-primary mb-4">{t('theBestPartTitle')}</h3>
              <p className="bestpartml">{t('theBestPartParagraph1')}</p>
              <p className="bestpartres">{t('theBestPartParagraph2')}</p>
            </div>
          </Col>
        </Row>

        <p className="mt-5 pt-5 text-center w-100"><Trans i18nKey="videoSummary"/></p>

        <div className="mx-auto w-100 mt-4" style={{maxWidth: '790px'}}>
          <video autoPlay muted className="w-100 " controls>
            <source src="https://businessexpoapi-stg.greenkosovo.com/Videos\Companies\637424707371945056.mp4" type="video/mp4"/>
          </video>
        </div>
      </Container>


      <div ref={registerScrollRef} style={{backgroundColor: '#ebebeb', marginTop: 60, paddingTop: 60, paddingBottom: 60}}>
        <Container>
          <div className="text-center">
            <Col md={12} className="mb-4 mb-md-0">

              <h2 className="app-text-primary mb-2 font-weight-bold">{t('registerBtn')}</h2>
              <div>
                <Button
                  text={t("businessBtn")}
                  type="successTransparent"
                  className="mt-4 mr-3"
                  style={{backgroundColor: !visitor ? '#80C32D' : 'transparent'}}
                  onClick={() => {
                    setVisitor(false)
                    setBoothPreference(boothPackages.premium)
                  }}
                />
                <Button
                  text={t("visitorBtn")}
                  type="successTransparent"
                  className="mt-4 ml-3"
                  style={{backgroundColor: visitor ? '#80C32D' : 'transparent'}}
                  onClick={() => {
                    setVisitor(true)
                    setBoothPreference(-1)
                  }}
                />
              </div>

              <form className="my-5">
                <div className="row">
                  <div className="col-md-4 px-3 mb-3">
                    <input className="register-input w-100 px-3 py-2 mb-2" ref={register} name="firstName"
                           onChange={e => setValue('firstName', e.currentTarget.value)}
                           placeholder={t('firstNameField')} type='text'/>
                    {errors.firstName &&
                    <div className="text-danger text-left small mx-2">{errors.firstName.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <input className="register-input w-100 px-3 py-2 mb-2" ref={register} name="lastName"
                           onChange={e => setValue('lastName', e.currentTarget.value)} placeholder={t('lastNameField')}
                           type='text'/>
                    {errors.lastName &&
                    <div className="text-danger text-left small mx-2">{errors.lastName.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <input className="register-input w-100 px-3 py-2 mb-2" ref={register} name="userName"
                           onChange={e => setValue('userName', e.currentTarget.value)} placeholder={t('eMailField')}
                           type='text'/>
                    {errors.userName &&
                    <div className="text-danger text-left small mx-2">{errors.userName.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <input className="register-input w-100 px-3 py-2 mb-2" ref={register} name="password"
                           onChange={e => setValue('password', e.currentTarget.value)} placeholder={t('passwordField')}
                           type='password'/>
                    {errors.password &&
                    <div className="text-danger text-left small mx-2">{errors.password.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <input className="register-input w-100 px-3 py-2 mb-2" ref={register}
                           name="confirmPassword" onChange={e => setValue('confirmPassword', e.currentTarget.value)}
                           placeholder={t('confirmPasswordField')} type='password'/>
                    {errors.confirmPassword &&
                    <div className="text-danger text-left small mx-2">{errors.confirmPassword.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <input className="register-input w-100 px-3 py-2 mb-2" ref={register} name="companyName"
                           onChange={e => setValue('companyName', e.currentTarget.value)}
                           placeholder={t('companyNameField')} type='text'/>
                    {errors.companyName &&
                    <div className="text-danger text-left small mx-2">{errors.companyName.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <select className="register-input w-100 px-3 py-2 mb-2" ref={register} name="sectorId"
                            onChange={e => setValue('sectorId', e.currentTarget.value)}>
                      {sectors.map((item: any) => (
                        <option value={item.id} key={item.id}>{item.name}</option>
                      ))}
                    </select>
                    {errors.sectorId &&
                    <div className="text-danger text-left small mx-2">{errors.sectorId.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <input className="register-input w-100 px-3 py-2 mb-2" ref={register} name="phoneNumber"
                           onChange={e => setValue('phoneNumber', e.currentTarget.value)}
                           placeholder={t('phoneNumberField')} type='text'/>
                    {errors.phoneNumber &&
                    <div className="text-danger text-left small mx-2">{errors.phoneNumber.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <select className="register-input w-100 px-3 py-2 mb-2" ref={register} name="countryId"
                            onChange={e => setValue('countryId', e.currentTarget.value)}>
                      {countries.map((item: any) => (
                        <option value={item.id} key={item.id}>{item.name}</option>
                      ))}
                    </select>
                    {errors.countryId &&
                    <div className="text-danger text-left small mx-2">{errors.countryId.message}</div>}
                  </div>

                  <div className="col-md-4 px-3 mb-3">
                    <input className="register-input w-100 px-3 py-2 mb-2" ref={register} name="city"
                           onChange={e => setValue('city', e.currentTarget.value)} placeholder={t('cityField')}
                           type='text'/>
                    {errors.city && <div className="text-danger text-left small mx-2">{errors.city.message}</div>}
                  </div>

                  {visitor &&
                  <div className="col-md-4 px-3 mb-3">
                      <input className="register-input w-100 px-3 py-2 mb-2" ref={register}
                             name="numbeEmployees" onChange={e => setValue('numbeEmployees', e.currentTarget.value)}
                             placeholder={t('numberOfEmployeesField')} type='text'/>
                    {errors.numbeEmployees &&
                    <div className="text-danger text-left small mx-2">{errors.numbeEmployees.message}</div>}
                  </div>}

                  {visitor &&
                  <div className="col-md-4 px-3 mb-3">
                      <input className="register-input w-100 px-3 py-2 mb-2" ref={register} name="jobPostion"
                             onChange={e => setValue('jobPostion', e.currentTarget.value)}
                             placeholder={t('jobPositionField')} type='text'/>
                    {errors.jobPostion &&
                    <div className="text-danger text-left small mx-2">{errors.jobPostion.message}</div>}
                  </div>}
                </div>

                <div className="text-center text-md-left">
                  <label>
                    <input name="GDPRText" type="checkbox" className="mr-2" ref={register}
                           onChange={e => setValue('GDPRText', e.currentTarget.checked)}/>
                    {t('GDPRText')}
                    {errors.GDPRText && <div className="text-danger text-left small">{errors.GDPRText.message}</div>}
                  </label>
                </div>
              </form>

              {!visitor && <>
                  <h4 className="app-text-primary mb-1">{t('standPreference')}</h4>
                  <p className="mb-5 text-muted">{t('standPreferenceSubtitle')}</p>

                  <div className="row justify-content-around align-items-end">
                      <div className="col-md-4">
                          <div className="package-image">
                              <img className="mx-auto" style={{width: '100%', maxWidth: 800}}
                                   src={require('../../assets/images/img.png')}/></div>
                          <div className="package-card ">
                              <h4>{t('platinium')}</h4>
                              <Button
                                  text={t('prefereThisBtn')}
                                  type="grayTransparent"
                                  className="mt-4 ml-3 text-uppercase"
                                  style={boothPreference === boothPackages.platinium ? {
                                    backgroundColor: '#80C32D',
                                    borderColor: '#80C32D',
                                    color: '#fff'
                                  } : {}}
                                  onClick={() => setBoothPreference(boothPackages.platinium)}
                              />
                          </div>
                      </div>
                      <div className="col-md-4 mt-5 mt-md-0">
                          <div className="package-image">
                              <img className="mx-auto" style={{width: '90%', maxWidth: 800}}
                                   src={require('../../assets/images/img.png')}/>
                          </div>
                          <div className="package-card">
                              <h4>{t('premium')}</h4>
                              <Button
                                  text={t('prefereThisBtn')}
                                  type="grayTransparent"
                                  className="mt-4 ml-3 text-uppercase"
                                  style={boothPreference === boothPackages.premium ? {
                                    backgroundColor: '#80C32D',
                                    borderColor: '#80C32D',
                                    color: '#fff'
                                  } : {}}
                                  onClick={() => setBoothPreference(boothPackages.premium)}
                              />
                          </div>
                      </div>
                      <div className="col-md-4 mt-5 mt-md-0">
                          <div className="package-image">
                              <img className="mx-auto" style={{width: '80%', maxWidth: 800}}
                                   src={require('../../assets/images/img.png')}/></div>
                          <div className="package-card">
                              <h4>{t('standard')}</h4>
                              <Button
                                  text={t('prefereThisBtn')}
                                  type="grayTransparent"
                                  className="mt-4 ml-3 text-uppercase"
                                  style={boothPreference === boothPackages.standard ? {
                                    backgroundColor: '#80C32D',
                                    borderColor: '#80C32D',
                                    color: '#fff'
                                  } : {}}
                                  onClick={() => setBoothPreference(boothPackages.standard)}
                              />
                          </div>
                      </div>
                  </div>

                  <Container className="p-0 pb-5 pt-5">
                    {boothPreference === boothPackages.standard &&
                    <img className="mx-auto shadow-lg w-100" style={{maxWidth: '790px'}} src={require('../../assets/images/C.png')}/>}
                    {boothPreference === boothPackages.premium &&
                    <img className="mx-auto shadow-lg w-100" style={{maxWidth: '790px'}} src={require('../../assets/images/showroom.png')}/>}
                    {boothPreference === boothPackages.platinium &&
                    <img className="mx-auto shadow-lg w-100" style={{maxWidth: '790px'}} src={require('../../assets/images/A.png')}/>}
                  </Container>
              </>}

              <Button
                text={t('submitFormBtn')}
                type="primary"
                className="text-uppercase"
                style={{padding: '10px 36px'}}
                onClick={handleSubmit(onRegisterClick)}
              />
            </Col>
          </div>
        </Container>
      </div>
      <h3 className="app-text-primary mb-4 mt-5 text-center"><strong>{t('FAQText')}</strong></h3>

      <Container>
        <div className="p-2 mb-5 app-text-primary">
          <Accordion title={t('accordionTitle1')}>
            <p>{t('accordionText1')}</p>
          </Accordion>
          <Accordion title={t('accordionTitle2')}>
            <p>{t('accordionText2')}</p>
          </Accordion>
          <Accordion title={t('accordionTitle3')}>
            <p>{t('accordionText3')}</p>
          </Accordion>
          <Accordion title={t('accordionTitle4')}>
            <p>{t('accordionText4')}</p>
            <ul>
              <li>{t('accordionTextUl1')}</li>
              <li>{t('accordionTextUl2')}</li>
              <li>{t('accordionTextUl3')}</li>
              <li>{t('accordionTextUl4')}</li>
              <li>{t('accordionTextUl5')}</li>
              <li>{t('accordionTextUl6')}</li>
            </ul>
          </Accordion>
          <Accordion title={t('accordionTitle5')}>
            <p>{t('accordionText5')}</p>
          </Accordion>
          <Accordion title={t('accordionTitle6')}>
            <p>{t('accordionText6')}</p>
            <p>{t('accordionTextUl7')}</p>
          </Accordion>
          <Accordion title={t('accordionTitle7')}>
            <p>{t('accordionText7')}</p>
            <p>{t('accordionTextUl8')}</p>
          </Accordion>
        </div>
      </Container>

      <Footer/>

    </div>
  );
}

export default Home;
